var exports = {
  "R": "file-tree-row__nVsQSE",
};

module.exports = exports;
